import { integrateWithTheme } from '@expPlatform/embeds/integrations/shopify/integrations';
import { supportedThemes } from '@expPlatform/embeds/integrations/shopify/integrations/themes/manifest';
export const Shopify = {
    integrateWithTheme: (schema_name, schema_version = 'default') => integrateWithTheme({ schema_name, schema_version }),
    // An object containing the supported theme names and their versions
    supportedThemes: Object.keys(supportedThemes).map((theme) => {
        return {
            name: theme,
            versions: Object.keys(supportedThemes[theme]),
        };
    }),
};
